<template>
    <div>
        <i-form label-position="top">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                       <h2>Atualizar os dados dos fiscais de todos os produtos da empresa</h2>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <Alert type="warning" show-icon>
                            Observações:
                            <template slot="desc">
                            <p>
                                <strong>Iniciais:</strong> Qualquer alteração realizada nessa tela alterará os dados fiscais de todos os produtos cadastrados até o momento.<br>
                                1º - Escolha um tipo de operação fiscal;<br>
                                2º - Insira os valores nos campos desejados;<br>
                                3º - Marque ou desmarque as caixas ao lado dos campos para escolher os campos a serem inseridos em todos os produtos<br>
                                4º - Se o usuário estiver na empresa matriz, terá a possibilidade de poder escolher se deseja replicar para todos as suas filiais tambem.<br>
                                <strong>Finais:</strong> Se tudo estiver certo, aperte em salvar e tudo estará feito!<br>
                                Dependendo do número de produtos e o número dos campos a serem atualizados, poderá ficar até 20 minutos atualizando os dados fiscais.<br>
                            </p>
                        </template>
                        </Alert>
                </vs-col>
                <vs-row :class="errors.items.length>0?'pb-4':''">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                        <form-item :error="errors.first('operação fiscal')" label="Tipo de Operação fiscal:">
                            <i-select filterable clearable v-model="form.operation" placeholder="Operação fiscal" size="large" name="operação fiscal" v-validate="'required'" @input="onChange()">
                                <Option v-for="item in options_operation" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </i-select>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="8">
                        <form-item label="Selecionar Todos:">
                            <div style="border-bottom: 1px solid #e9e9e9;">
                                <Checkbox
                                    :indeterminate="indeterminate"
                                    :value="check_all"
                                    @click.prevent.native="handleCheckAll">
                                </Checkbox>
                            </div>
                        </form-item>
                    </vs-col>
                </vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>NCM: </label>
                            <Checkbox v-model="form.ncm.check"
                                @on-change="checkAllGroupChange('ncm',form.ncm.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.ncm.value" size="large" @input="onChange('ncm')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Tributo Estadual: </label>
                            <Checkbox v-model="form.state_tribute.check"
                                @on-change="checkAllGroupChange('state_tribute',form.state_tribute.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.state_tribute.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('state_tribute')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Tributo Fed. Importado: </label>
                            <Checkbox v-model="form.tribute_fed_imported.check"
                                @on-change="checkAllGroupChange('tribute_fed_imported',form.tribute_fed_imported.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.tribute_fed_imported.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('tribute_fed_imported')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Tributo Fed. Nacional: </label>
                            <Checkbox v-model="form.tribute_fed_national.check"
                                @on-change="checkAllGroupChange('tribute_fed_national',form.tribute_fed_national.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.tribute_fed_national.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('tribute_fed_national')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Tributo Municipal: </label>
                            <Checkbox v-model="form.tribute_town.check"
                                @on-change="checkAllGroupChange('tribute_town',form.tribute_town.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.tribute_town.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('tribute_town')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>IPI: </label>
                            <Checkbox v-model="form.ipi.check"
                                @on-change="checkAllGroupChange('ipi',form.ipi.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.ipi.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('ipi')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>ICMS: </label>
                            <Checkbox v-model="form.icms.check"
                                @on-change="checkAllGroupChange('icms',form.icms.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.icms.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @input="onChange('icms')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Redução Base de Cálculo: </label>
                            <Checkbox v-model="form.base_calculation_reduction.check"
                                @on-change="checkAllGroupChange('base_calculation_reduction',form.base_calculation_reduction.check)">
                            </Checkbox>
                        </div>
                        <InputNumber
                            :max="100" :min="0"
                            v-model="form.base_calculation_reduction.value"
                            :step="0.01"
                            :formatter="value => `${value}%`"
                            :parser="value => value.replace('%', '')"
                            size="large"
                            @on-change="onChange('base_calculation_reduction')"
                            >
                        </InputNumber>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CSOSN: </label>
                            <Checkbox v-model="form.csosn.check"
                                @on-change="checkAllGroupChange('csosn',form.csosn.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.csosn.value" size="large" @input="onChange('csosn')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item label="CST ICMS:">
                        <div slot="label">
                            <label>CST ICMS: </label>
                            <Checkbox v-model="form.cst_icms.check"
                                @on-change="checkAllGroupChange('cst_icms',form.cst_icms.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cst_icms.value" size="large" @input="onChange('cst_icms')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CST IPI: </label>
                            <Checkbox v-model="form.cst_ipi.check"
                                @on-change="checkAllGroupChange('cst_ipi',form.cst_ipi.check)">
                            </Checkbox>
                        </div>
                        <Tooltip placement="top">
                            <i-input clearable v-model="form.cst_ipi.value" size="large" @input="onChange('cst_ipi')">
                            </i-input>
                            <div slot="content">
                                <label>Preencha este campo apenas<br> se sua empresa recolhe IPI.</label>
                            </div>
                        </Tooltip>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CST PIS: </label>
                            <Checkbox v-model="form.cst_pis.check"
                                @on-change="checkAllGroupChange('cst_pis',form.cst_pis.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cst_pis.value" size="large" @input="onChange('cst_pis')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CST COFINS: </label>
                            <Checkbox v-model="form.cst_cofins.check"
                                @on-change="checkAllGroupChange('cst_cofins',form.cst_cofins.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cst_cofins.value" size="large" @input="onChange('cst_cofins')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CFOP Dentro Estado: </label>
                            <Checkbox v-model="form.cfop_inside_state.check"
                                    @on-change="checkAllGroupChange('cfop_inside_state',form.cfop_inside_state.check)">
                                </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cfop_inside_state.value" size="large" @input="onChange('cfop_inside_state')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CFOP Fora Estado: </label>
                            <Checkbox v-model="form.cfop_out_state.check"
                                @on-change="checkAllGroupChange('cfop_out_state',form.cfop_out_state.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cfop_out_state.value" size="large" @input="onChange('cfop_out_state')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>CFOP Exterior: </label>
                            <Checkbox v-model="form.cfop_outside.check"
                                @on-change="checkAllGroupChange('cfop_outside',form.cfop_outside.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.cfop_outside.value" size="large" @input="onChange('cfop_outside')">
                        </i-input>
                    </form-item>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                    <form-item>
                        <div slot="label">
                            <label>Origem Mercadoria: </label>
                            <Checkbox v-model="form.origin_merchandise.check"
                                @on-change="checkAllGroupChange('origin_merchandise',form.origin_merchandise.check)">
                            </Checkbox>
                        </div>
                        <i-input clearable v-model="form.origin_merchandise.value" size="large" @input="onChange('origin_merchandise')">
                        </i-input>
                    </form-item>
                </vs-col>
            </vs-row>
        </i-form>
        <div class="floating-btn">
            <i-button v-show="show_save" @click="onSave" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        data:Array,
        show_save:Boolean
    },
    data:()=>({
        indeterminate:false,
        check_all: false, // selecionar todos
        check_all_group:[],
        form:{
            operation: null,
            ncm: {
                check:false,
                value:''
            },
            state_tribute: { // Tributo Estadual
                check:false,
                value: 0
            },
            tribute_fed_imported: { // Tributo Fed. Importado(TFN)
                check:false,
                value:0
            },
            tribute_fed_national: { // Tributo Fed. Nacional(TFN)
                check:false,
                value:0
            },
            tribute_town: { // Tributo Municipal
                check:false,
                value:0
            },
            ipi: {
                check:false,
                value:0
            },
            icms: {
                check:false,
                value:0
            },
            base_calculation_reduction: { // Redução Base de Cálculo
                check:false,
                value:0
            },
            csosn: {
                check:false,
                value:''
            },
            cst_icms: {
                check:false,
                value:''
            },
            cst_ipi: {
                check:false,
                value:''
            },
            cst_pis: {
                check:false,
                value:''
            },
            cst_cofins: {
                check:false,
                value:''
            },
            cfop_inside_state: { // CFOP Dentro Estado
                check:false,
                value:''
            },
            cfop_out_state: { // CFOP Fora Estado
                check:false,
                value:''
            },
            cfop_outside: { // CFOP Exterior
                check:false,
                value:''
            },
            origin_merchandise: { // Origem Mercadoria
                check:false,
                value:''
            },
        },
        options_operation:[
            {
                value: 1,
                label: 'Teste'
            },
        ]
    }),
    methods:{
        onSave() {
            this.$emit("input", this.form)
        },
        onChange(item=false) {
            if(item){
                if (!this.form[item].value == "") {
                    this.form[item].check = true
                } else {
                    this.form[item].check = false
                }
                this.checkAllGroupChange(item,this.form[item].check)
            }
            this.$emit("change")
            this.show_button = true
        },
        handleCheckAll() {
            if (this.indeterminate) {
                    this.check_all = false;
                } else {
                    this.check_all = !this.check_all;
                }
                this.indeterminate = false;
            if (this.check_all) {
                this.check_all_group = []
                Object.keys(this.form).map(item =>{
                    if(this.form[item]){
                        this.form[item].check = true
                        this.check_all_group.push(item)
                    }
                })
            } else {
                this.check_all_group = []
                Object.keys(this.form).map(item =>{
                    this.form[item]?this.form[item].check = false:''
                })
            }
        },
        checkAllGroupChange(item,check) {
            let data = this.check_all_group
            if(data.includes(item)) {
                !check?data = this.check_all_group.filter(value => {
                        return value != item
                }):''
            } else {
                check?data.push(item):''
            }
            if(data.length == 17){
                this.indeterminate = false
                this.check_all = true
            } else {
                if (data.length > 0) {
                    this.indeterminate = true
                    this.checkAll = false
                } else if(data.length == 0){
                    this.indeterminate = false
                    this.check_all = false
                }
            }
            this.check_all_group = data
        },

    },
    watch:{
        'form.state_tribute.value'(value){
            if(parseFloat(value)>100){
                this.form.state_tribute.value = 100
            }
        }
    },
    created(){
    },
}
</script>

<style lang="scss" scoped>
    h2 {
        margin-bottom: 20px;
    }
    p {
        margin-left: 10px;
    }
    .ivu-form-item {
        width: 100%;
        margin: 10px;
    }
    .ivu-collapse {
        width: 100%;
    }
    .ivu-date-picker {
        width: 100%;
    }
    .ivu-tooltip {
        width: 100%;
    }
    .ivu-input-number{
        width: 100%;
    }
</style>
